import React from "react";

export default function RejectedVendorIcon() {
  return (
    <svg
      width="90"
      height="90"
      viewBox="0 0 90 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="45" cy="45" r="45" fill="#FF0000" fill-opacity="0.2" />
      <circle
        cx="45.0006"
        cy="45.0006"
        r="32.1429"
        fill="#F44336"
        fill-opacity="0.1"
      />
      <path
        d="M53 38L37 53M37 38L53 53"
        stroke="#FF3C3C"
        strokeWidth="2.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M53 38L37 53M37 38L53 53"
        stroke="black"
        stroke-opacity="0.2"
        strokeWidth="2.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
